import { describeFault } from "@/lib/sophia/callGuard";

export function ErrorCard({ error, onRetry, className = "" }: { error: unknown; onRetry?: () => void; className?: string }) {
  if (!error) return null;
  const f = describeFault(error);
  return (
    <div role="alert" className={`flex flex-wrap items-center gap-2 rounded border border-destructive p-2 text-sm text-destructive ${className}`}>
      <span className="flex-1">{f.message}</span>
      {onRetry && <button onClick={onRetry} className="rounded border border-destructive px-2 py-1 text-xs">Retry</button>}
    </div>
  );
}
